var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("SSE数据：")]),_c('ul',_vm._l((_vm.messages),function(message){return _c('li',{key:message.id},[_vm._v(_vm._s(message.data))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }